import classNames from "classnames";
import React, { ReactElement } from "react";
import ReactSlider from "react-slider";
import { AppSliderHandler, AppSliderHandlerProps } from "./AppSliderHandler";

interface Props extends ReactSlider.ReactSliderProps {
  startHandler: AppSliderHandlerProps;
  endHandler?: AppSliderHandlerProps;
  invalid?: boolean;
  grayBars?: boolean;
}

export function AppSlider(props: Props): ReactElement {
  if (props.startHandler.direction !== "start") {
    throw new Error(`Start Handler must have direction="start"`);
  }

  if (props.endHandler !== undefined && props.endHandler.direction !== "end") {
    throw new Error(`End Handler must have direction="end"`);
  }

  return (
    <ReactSlider
      // https://github.com/mpowaga/react-slider/issues/137
      withBars={props.withBars}
      barClassName={"AppSliderBar"}
      className={classNames({
        AppSlider: true,
        WithMultipleHandlers: props.endHandler !== undefined,
        Invalid: props.invalid === true,
        GrayBars: props.grayBars === true,
      })}
      min={props.min}
      max={props.max}
      value={props.value}
      step={props.step}
      minDistance={props.minDistance}
      snapDragDisabled={props.snapDragDisabled}
      disabled={props.disabled}
      onBeforeChange={props.onBeforeChange}
      onAfterChange={props.onAfterChange}
      onChange={props.onChange}
    >
      {[
        <AppSliderHandler key="0" direction="start" disabled={props.startHandler.disabled}>
          {props.startHandler.children}
        </AppSliderHandler>,

        props.endHandler !== undefined ? (
          <AppSliderHandler key="1" direction="end" disabled={props.endHandler.disabled}>
            {props.endHandler.children}
          </AppSliderHandler>
        ) : undefined,
      ].filter((child) => child !== undefined)}
    </ReactSlider>
  );
}
